export const excludeMenuList = ['requirement', 'student-requirement', 'online-course', 'student-blog', 'video', 'setting-requirement'];